@let heroBannerList = heroBanners();
@if (heroBannerList?.length) {
  <app-hero-banner id="main" tabindex="-1" [activeBanners]="heroBannerList"></app-hero-banner>
}
<div class="content">
  <app-banner class="top-banner"></app-banner>
  @if (topTextBanner) {
    <app-richtext-box [content]="topTextBanner"></app-richtext-box>
  }
  @if (primarySection) {
    <div class="deals-wrapper">
      @let link = primarySection.link;
      <div class="deals primary" [class.border]="secondarySections && secondarySections.length > 0" [class.kiosk]="isKiosk">
        <div class="deals-header">
          <h1>{{ primarySection.title }}</h1>
          @if (link.name) {
            <a [routerLink]="link.url" [queryParams]="link.params">{{ link.name }}</a>
          }
        </div>

        @let products = primarySection.products | async;
        <div
          class="deals-content"
          [class.rows-1]="products.length <= 4"
          [class.rows-2]="4 < products.length && products.length <= 8"
          [class.rows-3]="8 < products.length && products.length <= 12"
          [class.rows-4]="12 < products.length && products.length <= 16"
          [class.rows-5]="16 < products.length"
          [style.--mobile-rows]="products.length > 10 ? 10 : products.length"
        >
          @for (product of products; track $index) {
            <app-product-card [product]="product" [big]="true"></app-product-card>
          }
        </div>

        @if (link.name) {
          <app-text-button [routerLink]="link.url" [queryParams]="link.params">
            {{ link.name }}
          </app-text-button>
        }
      </div>
      @for (section of secondarySections; track $index) {
        <div class="deals secondary" [class.kiosk]="isKiosk">
          @let link = section.link;
          <div class="deals-header">
            <h2>{{ section.title }}</h2>
            @if (link.name) {
              <a [routerLink]="link.url" [queryParams]="link.params">{{ link.name }}</a>
            }
          </div>

          @let products = section.products | async;
          <div
            class="deals-content"
            [class.rows-1]="products.length <= 4"
            [class.rows-2]="4 < products.length && products.length <= 8"
            [class.rows-3]="8 < products.length && products.length <= 12"
            [class.rows-4]="12 < products.length && products.length <= 16"
            [class.rows-5]="16 < products.length"
          >
            @for (product of products; track $index) {
              <app-product-card [product]="product" [big]="true"></app-product-card>
            }
          </div>
          @if (link.name) {
            <app-text-button [routerLink]="link.url" [queryParams]="link.params">
              {{ link.name }}
            </app-text-button>
          }
        </div>
      }
    </div>
  }
  @if (bottomBanner && bottomBanner.image) {
    <app-full-banner [content]="bottomBanner" class="bottom-banner"></app-full-banner>
  }
  @if (bottomTextBanner) {
    <app-richtext-box [content]="bottomTextBanner" class="bottom-text-banner"></app-richtext-box>
  }
</div>
